import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe for formatting phone numbers into a standard account phone number format.
 * Takes a phone number input and transforms it into the format (XXX) XXX-XXXX or (XXX) XXXX
 * if the number is less than 7 digits after area code.
 * If the input contains non-numeric characters (excluding a leading plus sign),
 * it returns the original value unchanged.
 * Handles trimming of whitespace from the input string.
 * Returns an empty string for null, undefined, or empty inputs.
 */
@Pipe({ name: 'accountPhoneNumber', standalone: false })
export class AccountPhoneNumberPipe implements PipeTransform {
  /**
   * Transforms a phone number into a formatted string with area code and optional number segments.
   *
   * @param phoneNumber - The input phone number to transform, can be of any type
   * @return - The formatted phone number string or original input if invalid
   */
  // eslint-disable-next-line class-methods-use-this
  transform(phoneNumber: unknown): string {
    if (!phoneNumber) return '';
    const original = String(phoneNumber).trim();
    const value = original.replace(/^\+/, '');
    if (/[^0-9]/.test(value)) return original;
    const city = value.slice(0, 3);
    let number = value.slice(3, 10);
    if (number.length > 3) number = `${number.slice(0, 3)}-${number.slice(3, 7)}`;
    return number ? `(${city}) ${number}`.trim() : `(${city}`;
  }
}
